const routerMessage = {
  path: '/message',
  name: 'message',
  meta: {
    title: '消息中心',
    needLogin: true,
    transitionName: 'router',
  },
  component: () => import('@/pages/module-message/index.vue'),
};

export default routerMessage;
